exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-962a29f6] .wish-comment-content a {\n  text-decoration: underline;\n  color: currentColor;\n  text-underline-position: from-font\n}\n", ""]);

